import { BILLING_ADDRESS_SCOPE } from '../../../../../constants/billing'
import { TextDistrictInstruction } from './TextDistrictInstruction'

export class BillingDistrictInstruction extends TextDistrictInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({ label, waitForNoLoaders, value })
    this.name = 'BillingDistrict'
    this.scope = BILLING_ADDRESS_SCOPE
  }

  setDefaultValue (params) {
    this.value = params.billingInformation.district
  }
}
